import { useSuspenseQuery } from '@tanstack/react-query';
import { ApiCallsV2 } from '../../../api/apiV2';
import { USER_PERIOD_BY_DATE } from '../../../constants/queryKeys';

export const usePeriodByDate = (date: string) => {
    return useSuspenseQuery({
        queryKey: [USER_PERIOD_BY_DATE, date],
        queryFn: () => ApiCallsV2.getUserPeriodByDate({ date }).then(res => res.data),
    });
};
